module.exports = __webpack_public_path__ + "static/wedding-home-on-macbook_PLACEHOLDER-8fba990b090bd2a836f20a685f07c6d4.jpg";